import { deviceTokenRequestSchema, deviceTokenResponseSchema, devicesResponseSchema, refreshTokenRequestSchema, } from '@fewerbags/schema';
function body(schema, value) {
    return schema.parse(value);
}
/**
 * Mobile device/token auth (Phase 5). Separate from `auth.*` (cookie login):
 * `create` exchanges credentials for a bearer token pair the same way
 * `auth.login` starts a cookie session; `refresh` rotates that pair;
 * `revoke` is logout for a device. Pass the resulting `accessToken` back to
 * `createApiClient` via `getAccessToken` to authenticate subsequent calls.
 */
export function createAuthTokensApi(http, base) {
    return {
        /** POST /auth/token — exchanges credentials for an access/refresh pair. */
        create: async (input) => http.post(`${base}/token`, body(deviceTokenRequestSchema, input), {
            parse: deviceTokenResponseSchema,
            silent401: true,
        }),
        /** POST /auth/token/refresh — rotates the pair; the old refresh token stops working. */
        refresh: async (input) => http.post(`${base}/token/refresh`, body(refreshTokenRequestSchema, input), {
            parse: deviceTokenResponseSchema,
        }),
        /** POST /auth/token/revoke — idempotent logout for this device; always succeeds. */
        revoke: async (input) => http.post(`${base}/token/revoke`, body(refreshTokenRequestSchema, input)),
        devices: {
            /** GET /auth/devices — every live device session for the signed-in user. */
            list: async () => http.get(`${base}/devices`, { parse: devicesResponseSchema }),
            /** DELETE /auth/devices/:id — sign a device out remotely. */
            revoke: async (id) => http.del(`${base}/devices/${encodeURIComponent(id)}`),
        },
    };
}
//# sourceMappingURL=auth-tokens.js.map